import { LocationQuery, useLocationQuery } from '@modules/layout/hooks';

export type ActionLogSectionsListFilters = {
    allLaps?: string;
    employeeId?: string;
    date?: string;
    timezone?: string;
};

export type ActionLogSectionsFiltersQuery = {
    filters: ActionLogSectionsListFilters;
} & Pick<LocationQuery, 'query' | 'setQuery'>;

const useActionLogSectionsFiltersQuery = (): ActionLogSectionsFiltersQuery => {
    const { query, setQuery } = useLocationQuery();

    const result: ActionLogSectionsFiltersQuery = {
        filters: {
            allLaps: query.allLaps ? String(query.allLaps) : undefined,
            employeeId: query.employeeId ? String(query.employeeId) : undefined,
            date: query.date ? String(query.date) : undefined,
            timezone: query.timezone ? String(query.timezone) : undefined,
        },
        query,
        setQuery,
    };

    return result;
};

export { useActionLogSectionsFiltersQuery };
